var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowX(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 18.6914 16.416",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    height: 16.416,
    opacity: 0,
    width: 18.6914,
    x: 0,
    y: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.917969 0C0.400391 0 0.166016 0.332031 0.0878906 0.722656C0.0195312 1.02539 0 1.50391 0 2.08008C0 6.80664 1.89453 8.83789 6.52344 8.83789L13.3496 8.83789L15.7422 8.70117L12.4512 11.6992L10.2832 13.9062C10.127 14.0723 10.0488 14.2969 10.0488 14.5312C10.0488 15.0195 10.4199 15.3711 10.9082 15.3711C11.1328 15.3711 11.3477 15.2832 11.5625 15.0781L18.0273 8.62305C18.2324 8.42773 18.3301 8.20312 18.3301 7.95898C18.3301 7.72461 18.2324 7.49023 18.0273 7.30469L11.543 0.820312C11.3477 0.634766 11.1328 0.556641 10.9082 0.556641C10.4199 0.556641 10.0488 0.908203 10.0488 1.39648C10.0488 1.63086 10.1367 1.85547 10.2832 2.01172L12.4512 4.21875L15.752 7.23633L13.3496 7.08984L6.61133 7.08984C3.02734 7.08984 1.76758 5.61523 1.76758 1.99219C1.76758 1.52344 1.79688 1.21094 1.79688 0.859375C1.79688 0.351562 1.42578 0 0.917969 0Z",
    fill: "black"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowX);
export default __webpack_public_path__ + "static/media/ArrowX.69a0e9953df7fcf2eff631862f9ad4b6.svg";
export { ForwardRef as ReactComponent };